export default "__VITE_ASSET__DRlVPEO2__"